import PermissionsContainer from "./Permissions";
export default PermissionsContainer;
